import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const MonitorStop: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '9', y: '7', width: '6', height: '6' }],
    ['rect', { width: '20', height: '14', x: '2', y: '3', rx: '2' }],
    ['path', { d: 'M12 17v4' }],
    ['path', { d: 'M8 21h8' }],
  ],
];

export default MonitorStop;
